import { DataBusFacade, DataSubscription, DataUpdate } from "remote-module-context";

export class DataBus {
	private subscriptions: DataSubscription<unknown>[] = [];
	private store: Record<string, unknown> = {};

	createFacade(): DataBusFacade {
		return {
			subscribe: (subscription) => this.subscribe(subscription),
			dispatch: (update) => this.dispatch(update),
		};
	}

	private dispatch<T>(message: DataUpdate<T>): void {
		this.store[message.key] = message.value;
		for (const subscription of this.subscriptions) {
			if (message.key === subscription.key) {
				subscription.changeHandler(message.value);
			}
		}
	}

	private subscribe<T>(subscription: DataSubscription<T>): () => void {
		this.subscriptions = [...this.subscriptions, subscription];
		if (subscription.key in this.store) {
			subscription.changeHandler(this.store[subscription.key] as T);
		}

		return () => this.unsubscribe(subscription);
	}

	private unsubscribe = (subscriptionToRemove: DataSubscription<unknown>) => {
		this.subscriptions = this.subscriptions.filter((subscription) => subscription !== subscriptionToRemove);
	};
}
